import { AfterViewInit, Component, inject } from '@angular/core';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { MenuItem, MessageService } from 'primeng/api';
import { SidebarService } from '../../../services/menu/sidebar.service';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { RoutingService } from '../../../services/routing.service';
import { BaseListComponent } from '../base-list/base-list.component';
import { Help } from '../../../models/help';
import { HelpStore } from '../../../stores/help/help.state';
import { TableModule } from 'primeng/table';
import { TableCaptionComponent } from '../../molecules/table-list-caption/table-list-caption.component';
import { TableListActionsComponent } from '../../molecules/table-list-actions/table-list-actions.component';
import { SidebarModule } from 'primeng/sidebar';
import { HeaderComponent } from '../../atoms/header/header.component';
import { MaskComponent } from '../mask/mask.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-help-list',
  standalone: true,
  imports: [
    TableModule,
    TableCaptionComponent,
    RouterLink,
    TableListActionsComponent,
    SidebarModule,
    HeaderComponent,
    RouterOutlet,
    MaskComponent,
    NgIf,
  ],
  templateUrl: './help-list.component.html',
  styleUrl: './help-list.component.scss',
})
export class HelpListComponent
  extends BaseListComponent<Help>
  implements AfterViewInit
{
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-8',
    icon: 'fas fa-book',
    headerText: 'Dokumentation',
  };

  readonly store = inject(HelpStore);
  override menuItems: MenuItem[] = [];
  override sidebarId = 'help-administration';

  constructor(
    protected sidebarService: SidebarService,
    router: Router,
    route: ActivatedRoute,
    messageService: MessageService,
    confirmationDialogService: ConfirmationDialogService,
    routingService: RoutingService
  ) {
    super(
      router,
      route,
      messageService,
      confirmationDialogService,
      routingService
    );
  }

  /**
   * Lifecycle hook that is called after Angular has fully initialized the component's view.
   * This method is commonly used to perform tasks that require access to the fully rendered view.
   * In this case, it sets the sidebar configuration using the provided configuration data.
   *
   * @return {void} Does not return a value.
   */
  ngAfterViewInit(): void {
    this.sidebarService.setConfiguration(this.sidebarConfig);
  }
}
